/*
  Cart drawer / cart page cross-sell (snippets/cart-items.liquid).

  Up to two complementary items, chosen in the theme editor (settings.cart_cross_sell_product
  and settings.cart_cross_sell_product_2), each its own x-data="CartCrossSell(...)" row.
  "Tilføj" adds it via the same /cart/add.js + section-rendering flow as everywhere
  else in the theme, then fires the theme's own `shapes:modalcart:afteradditem` event
  so cart-items.js / cart-footer.js / cart-count.js morph in the fresh cart state
  exactly like a normal product add.

  Registered once via `alpine:init` from a <script> loaded inside cart-items.liquid.
  That snippet gets Alpine-morphed on every cart change, but this registration only
  needs to happen once per page load; Alpine's own morph plugin (not a plain
  innerHTML swap) re-initializes the `x-data="CartCrossSell(...)"` element on every
  morph, the same way it already does for the cart items list itself.
*/
document.addEventListener('alpine:init', () => {
  Alpine.data('CartCrossSell', (variantId) => ({
    adding: false,
    error: '',

    addToCart() {
      if (this.adding || !variantId) return;

      this.adding = true;
      this.error = '';

      const config = fetchConfigDefaults('javascript');
      config.body = JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart-items,cart-footer,cart-item-count,cart-live-region',
        sections_url: window.location.pathname,
      });

      fetch(theme.routes.cart_add_url, config)
        .then((res) => res.json())
        .then((data) => {
          if (data.status) {
            this.error = data.description || data.message || window.theme.strings.cartError;
            return;
          }

          document.body.dispatchEvent(
            new CustomEvent('shapes:modalcart:afteradditem', {
              bubbles: true,
              detail: { response: data },
            })
          );
        })
        .catch(() => {
          this.error = window.theme.strings.cartError;
        })
        .finally(() => {
          this.adding = false;
        });
    },
  }));
});
